export const translations = {
  fr: {
    // Header
    header: {
      home: 'Accueil',
      about: 'À propos',
      services: 'Mes accompagnements',
      booking: 'Prendre rendez-vous',
      contact: 'Contact',
      test: 'Test gratuit',
      name: 'Stéphanie Ruiz',
      role: 'Numérologue · Coach de vie',
      specialty: 'Accompagnement familial et de couple',
      languageLabel: 'Langue:'
    },
    
    // Footer
    footer: {
      name: 'Stéphanie (Stef) Ruiz',
      tagline: 'Numérologue · Coach de vie · Accompagnement familial et de couple',
      location: 'Ibiza en présentiel et à distance partout dans le monde',
      contact: 'Contact',
      navigation: 'Navigation',
      follow: 'Suivez-moi',
      legalNotice: 'Mentions légales',
      privacy: 'Politique de confidentialité',
      copyright: '© 2026 Stef Ruiz - Comprendre qui l\'on est. Tous droits réservés.'
    },
    
    // Common buttons
    buttons: {
      bookNow: 'Prendre rendez-vous',
      bookDiscovery: 'Prendre rendez-vous pour un appel découverte gratuit',
      sendMessage: 'Envoyer ma demande',
      readMore: 'En savoir plus'
    },
    
    // WhatsApp
    whatsapp: {
      tooltip: 'Contactez-moi sur WhatsApp',
      message: 'Bonjour Stef, je souhaite obtenir des informations sur vos accompagnements.'
    }
  },
  
  es: {
    // Header
    header: {
      home: 'Inicio',
      about: 'Sobre mí',
      services: 'Mis acompañamientos',
      booking: 'Reservar cita',
      contact: 'Contacto',
      test: 'Test gratuito',
      name: 'Stéphanie Ruiz',
      role: 'Numeróloga · Coach de vida',
      specialty: 'Acompañamiento familiar y de pareja',
      languageLabel: 'Idioma:'
    },
    
    // Footer
    footer: {
      name: 'Stéphanie (Stef) Ruiz',
      tagline: 'Numeróloga · Coach de vida · Acompañamiento familiar y de pareja',
      location: 'Ibiza presencial y online en todo el mundo',
      contact: 'Contacto',
      navigation: 'Navegación',
      follow: 'Sígueme',
      legalNotice: 'Aviso legal',
      privacy: 'Política de Privacidad',
      copyright: '© 2026 Stef Ruiz - Comprender quién eres. Todos los derechos reservados.'
    },
    
    // Common buttons
    buttons: {
      bookNow: 'Reservar cita',
      bookDiscovery: 'Reservar llamada gratuita',
      sendMessage: 'Enviar mi solicitud',
      readMore: 'Saber más'
    },
    
    // WhatsApp
    whatsapp: {
      tooltip: 'Contáctame por WhatsApp',
      message: 'Hola Stef, me gustaría obtener información sobre tus servicios.'
    }
  }
};
